import { usePortalAuth, AppRole } from './usePortalAuth';

export function useRole() {
  const { roles, isSuperAdmin, isAdmin, isTeam, isClient, isLoading } = usePortalAuth();

  const hasRole = (role: AppRole): boolean => roles.includes(role);
  const hasAnyRole = (checkRoles: AppRole[]): boolean => checkRoles.some(role => roles.includes(role));

  const canManageUsers = isAdmin;
  const canManageOrganizations = isAdmin;
  const canManageRoles = isAdmin;

  const canUploadReports = isAdmin || isTeam;
  const canManageReleases = isAdmin || isTeam;
  const canManageInvoices = isAdmin || isTeam;
  const canUploadFiles = isAdmin || isTeam;

  const canViewReports = true;
  const canViewInvoices = true;
  const canViewReleases = true;
  const canViewFiles = true;
  const canCreateTickets = true;
  const canManageTickets = isAdmin || isTeam;

  return {
    roles,
    isSuperAdmin,
    isAdmin,
    isTeam,
    isClient,
    isLoading,
    hasRole,
    hasAnyRole,
    canManageUsers,
    canManageOrganizations,
    canManageRoles,
    canUploadReports,
    canManageReleases,
    canManageInvoices,
    canUploadFiles,
    canViewReports,
    canViewInvoices,
    canViewReleases,
    canViewFiles,
    canCreateTickets,
    canManageTickets,
  };
}
